import type { PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, type SharedValue } from 'react-native-reanimated';

import { cardLayerPose } from '../card-layer-geometry';

/** Stable keyed layers retain the next image while it moves into the foreground. */
export function OfferHubCardLayer({
  current,
  itemId,
  promotingId,
  promotion,
  children,
}: PropsWithChildren<{
  current: boolean;
  itemId: string;
  promotingId: SharedValue<string | null>;
  promotion: SharedValue<number>;
}>) {
  const height = useSharedValue(0);
  const style = useAnimatedStyle(() => {
    const pose = cardLayerPose(height.value, current ? 1 : promotingId.value === itemId ? promotion.value : 0);
    return { transform: [{ translateY: pose.translateY }, { scale: pose.scale }] };
  });
  return (
    <Animated.View
      collapsable={false}
      onLayout={(event) => height.set(event.nativeEvent.layout.height)}
      pointerEvents={current ? 'auto' : 'none'}
      accessibilityElementsHidden={!current}
      aria-hidden={!current}
      importantForAccessibility={current ? 'auto' : 'no-hide-descendants'}
      style={[StyleSheet.absoluteFill, { zIndex: current ? 1 : 0 }, style]}
    >
      {children}
    </Animated.View>
  );
}
